import createHWAgentErrorMessage from './createHWAgentErrorMessage'
import errorMessages from './errorMessages'
import i18next from 'i18next'

// common error
export const logError = (name: string, action: string, error: any) => {
    const { message, arg } = errorMessages(error)
    console.log(`[${name}] ${action} with error: ${i18next.t(message, arg)}`)
}

// hw agent error
export const logHWError = (name: string, action: string, error: any) => {
    const errorMessage = createHWAgentErrorMessage(error)
    console.log(`[${name}] ${action} with error: ${errorMessage}`)
}
